<template>
    <v-select
        :value="item.value !== null ? item.value : item.default"
        :items="options"
        :label="$t(item.name)"
        @change="changeValue($event, item)"
        hide-details
        :clearable="clearable"
        :id="id"
        :alvqa="alvqa"
        :disabled="item.readonly === '1' ? true : false"
        menu-props="offset-y, offset-overflow"
    >
        <template v-slot:item="{ item }">
            <div :alvqa="alvqa + '-option-' + item.value">
                {{ typeof(item) === 'object' ? item.text : item }}
            </div>
        </template>
        <template v-slot:selection="{ item }">
            <div 
                class="text-no-wrap text-truncate" 
                :alvqa="alvqa + '-selection'">
                {{ typeof(item) === 'object' ? item.text : item }}
            </div>
        </template>
    </v-select>
</template>

<script>
export default {
    name: "SettingsDropdown",
    props: {
        item: Object,
        options: Array,
        clearable: Boolean,
        id: String,
        alvqa: String
    },
    methods: {
        changeValue(newValue, item) {
            item.value = newValue
        },
    }
}
</script>